module.exports = __webpack_public_path__ + "img/x.e266b596.png";